module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/DOCTOR'S SBI CARD.b0d884bb.png";